import React from 'react'

export const ContainerContext = React.createContext<HTMLElement>(document.body)

export function useContainer() {
    return React.useContext(ContainerContext)
}
